const fetchData:string = `
    {
    themeGeneralSettings {
      Options {
        searchDisclaimer {
          title
          description
        }
      }
    }
  }
`;
export default fetchData;
